<template>
    <button
        type="button"
        class="hover:bg-indigo-200 inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        :class="{
            'text-indigo-700 bg-indigo-100': isSoundOn,
            'text-gray-700 bg-gray-100': !isSoundOn,
        }"
        @click="isSoundOn = !isSoundOn"
    >
        <IconVolume class="w-6 h-6" v-if="isSoundOn" />
        <IconVolume3 class="w-6 h-6" v-else />
    </button>
</template>
<script setup>
import { useVModel } from '@vueuse/core';
import { IconVolume, IconVolume3 } from '@tabler/icons-vue';

let emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: Boolean,
    },
});

const isSoundOn = useVModel(props, 'modelValue', emit);
</script>
